import { jwtDecode } from "jwt-decode";

export async function getUserData() {
  try {
    let userTokenEncoded = await OfficeRuntime.auth.getAccessToken();
    let userToken: any = jwtDecode(userTokenEncoded); // Using the https://www.npmjs.com/package/jwt-decode library.
    return {
      name: userToken.name || "",
      email: userToken.preferred_username || "",
      id: userToken.oid || "",
      token: userTokenEncoded || "",
    };
  } catch (exception) {
    if (exception.code === 13003) {
      // SSO is not supported for domain user accounts, only
      // Microsoft 365 Education or work account, or a Microsoft account.
      console.error("SSO is not supported for domain user accounts.");
      return {
        name: "",
        email: "",
        id: "",
        token: "",
      };
    } else {
      // Handle error
      console.error("Error getting user data:", exception);
      return {
        name: "",
        email: "",
        id: "",
        token: "",
      };
    }
  }
}
